import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Box, Button, Heading, Text } from 'grommet'
import Modal from 'components/common/Modal'
import { SIGN_UP } from 'components/common/Routes'

const AppButtonLabel = (props) => {
    const { body, color, heading} = props
    return(
        <Box
            align="center"
            alignContent="center"
            margin={{ bottom: "small" }}
        >
            <Heading color={color} level="2" margin={{ top: 'xsmall' }}>
                {heading}
            </Heading>
            <Text color={color} size="medium" weight='bold'>
                {body}
            </Text>
        </Box>
    )
} 

const AppButton = (props) => {
    const { labelBody, labelColor, labelHeading, onClick } = props 
    return (
        <Button
            onClick={onClick}
            label={
                <AppButtonLabel
                    body={labelBody}
                    color={labelColor}
                    heading={labelHeading}
                />
            }
            plain={true}
        />
    )
}

const AppPromo = (props) => {
    const { appIsActive, heading, body, onClick } = props 
    return(
        <Fragment> 
            <Heading color='accent-2' level='3'>{heading}</Heading>
            <Text color='brand' weight='bold'>{body}</Text>
            { appIsActive && 
                <Button 
                    label='Try for Free'
                    margin={{ vertical:'small' }} 
                    onClick={onClick}
                    primary={true} 
                />
            }
        </Fragment>
    )
}

const AppCard = (props) => {
    const { 
        appIsActive,
        appRoute,
        authorizedUser, 
        background, 
        basis,
        history, 
        labelColor, 
        labelHeading, 
        labelBody,
        modalBorderColor,
        modalCloserColor, 
        promoHeading,
        promoBody, 
    } = props 
    
    const [state, setState] = useState({ showPromoModal: false})
    
    const handleAppButton = () => {
        if (authorizedUser && appIsActive) {history.push(appRoute)}
        setState({ ...state, showPromoModal: true })
    } 
    
    return( 
        <> 
            {state.showPromoModal && 
                <Modal
                    children={
                        <AppPromo 
                            appIsActive={appIsActive}
                            heading={promoHeading} 
                            body={promoBody} 
                            onClick={ () => { history.push(SIGN_UP) } }
                        />
                    }
                    borderColor={modalBorderColor}
                    closerColor={modalCloserColor}
                    onClose={ () => { setState({ showPromoModal: false }) } }
                />
            }
            <Box
                align="center"
                background={background}
                basis={basis}
                height="small"
                justify="center"
                margin={{
                    bottom: 'xsmall',
                    left: 'xsmall',
                    right: 'xsmall',
                    top: 'xsmall'
                }}
                pad={{ horizontal: 'small'}}
            >
                {<AppButton 
                    labelColor={labelColor} 
                    labelHeading={labelHeading} 
                    labelBody={labelBody}
                    onClick={handleAppButton} 
                />}
            </Box>
        </>
    )
}

export default withRouter(AppCard)